import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import AdjustEntriesForm from '@entries/components/forms/adjust-entries-form/adjust-entries-form.vue';

@Component({
  name: 'bpc-adjust-entries-modal',
  components: {
    'bpc-adjust-entries-form': AdjustEntriesForm,
  },
})
export default class AdjustCreditsModal extends Vue {
  declare $refs: {
    adjustEntriesForm: InstanceType<typeof AdjustEntriesForm> & {
      formModel: AnyEntity;
    };
  };
  // PROPS
  @Prop({ type: String, default: 'adjust-credits-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop(Object) entity;

  // DATA
  public validateErrors = {};
  public requestSent: boolean = false;
  showModalIndex = null;
  readonly errorMessageText: string = 'global.generic.error_form_action';
  public formModel = {};
  // COMPUTED
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    this.showModalIndex = Date.now();
    this.initVars();
    if (this.showModal) {
      this.openModal();
    }
  }

  initVars() {
    this.requestSent = false;
    this.validateErrors = null;
  }

  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
    this.initVars();
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onConfirm() {
    this.requestSent = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('entries');
    // Fetch data
    const formModel = this.$refs?.adjustEntriesForm?.formModel;
    const payload: AnyEntity = {
      remaining_credits: formModel.remaining_credits,
    };

    this.$bpcApi
      .put(basePath + '/' + this.entity.id + '/adjust-entries-remaining/', payload)
      .subscribe(
        res => {
          this.requestSent = true;
          this.$emit('adjusted-remaining-entries');
          this.closeModal();
        },
        error => {
          this.validateErrors = error?.response.data.errors;
          this.requestSent = false;
          if (error?.response.data.errors) {
            this.$bpcMessage.showErrorMessage({ text: this.errorMessageText });
          }
          this.closeModal();
        },
      );
  }

  onValidationWarning(event) {
    console.log('onValidationWarning', event);
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
